import { useBlobUrl } from "../../../hooks/helpers/storageAccount";
import { ImageOff } from "lucide-react";
import { Image } from "../../ui/image/Image";

export interface BlobImageProps {
  src?: string;
  className?: string;
  fallback?: React.ReactNode;
}

const BlobImage = ({ src, className, fallback }: BlobImageProps) => {
  const blobUrl = useBlobUrl(src);

  return (
    <Image
      src={blobUrl}
      className={className}
      fallback={fallback ?? <ImageOff size={25} />}
    />
  );
};

export default BlobImage;
